import React, { useState, useEffect } from 'react';
import { checkAuth } from '../utils/auth';
import LoginForm from './LoginForm';
import './AuthGuard.css';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const authenticated = checkAuth();
    setIsAuthenticated(authenticated);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner"></div>
        <p>Laden...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginForm onSuccess={() => {
      setIsAuthenticated(true);
    }} />;
  }

  return <>{children}</>;
};

export default AuthGuard;

